import { useState } from "react";
import { t } from '../locales/translate.js';
function Element({ apiCall, user, setCookie }) {


  const [name, setName] = useState(user.name || "");
  const [email, setEmail] = useState(user.email || "");
  //phone
  const [phone, setPhone] = useState(user.phone || "");
  //'bank_account' => 'nullable|string|max:255',
  const [bankAccount, setBankAccount] = useState(user.bank_account || "");
  // 'bank_account_name' => 'nullable|string|max:255',
  const [bankAccountName, setBankAccountName] = useState(user.bank_account_name || "");
  // 'interested_in_meat_return' => 'nullable|boolean',
  const [interestedInMeatReturn, setInterestedInMeatReturn] = useState(user.interested_in_meat_return || false);
  // 'password' => 'nullable|string|min:8',
  const [password, setPassword] = useState("");
  // password repeat
  const [passwordRepeat, setPasswordRepeat] = useState("");
  //update password switch
  const [updatePassword, setUpdatePassword] = useState(false);
  //emails
  const [emails, setEmails] = useState(user.invoice_emails || []);

  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);

  function handleSubmit(e) {
    e.preventDefault();
    setError(null);
    setSuccess(null);

    const data = {
      name,
      email,
      phone,
      bank_account: bankAccount,
      bank_account_name: bankAccountName,
      interested_in_meat_return: interestedInMeatReturn,
      invoice_emails: emails,
    };

    if (updatePassword) {
      if (!password || !passwordRepeat) {
        setError(t('password_and_repeat_required'));
        return;
      }
      if (password !== passwordRepeat) {
        setError(t('passwords_do_not_match'));
        return;
      }
      data.password = password;
    }

    apiCall("PUT", `user/${user.id}`, data)
      .then(({ response, error }) => {
        if (error) {
          console.error(response);
          setError(error);
          return;
        }

        console.log(t('profile_updated_successfully'), response);
        // update user cookie
        setCookie('user', response, { path: '/' });
        setSuccess(t('profile_updated_successfully'));
        
        setTimeout(() => {
          setSuccess(null);
        }, 3000);
      });
  }

  return (
    <div className="edit-profile">
      <div className="row">

        <div className="col-xl-12">
          <form className="card" onSubmit={handleSubmit}>
            <div className="card-header">
              <h5 className="card-title">{t('edit_profile')}</h5>
            </div>
            <div className="card-body">
              <div className="row custom-input">
                <div className="col-xxl-6 box-col-12">
                  <div className="mb-3">
                    <label className="form-label" htmlFor="Name">{t('name')}</label>
                    <input className="form-control" id="Name" type="text" placeholder={t('name')} onChange={(e) => setName(e.target.value)} value={name} readOnly={!!user.id} />
                  </div>
                </div>

                <div className="col-xxl-6 box-col-12">
                  <div className="mb-3">
                    <label className="form-label" htmlFor="Email">{t('email')}</label>
                    <input className="form-control" id="Email" type="email" placeholder={t('email')} onChange={(e) => setEmail(e.target.value)} value={email} readOnly={!!user.id} />
                  </div>
                </div>

                {user?.estate_deliverer > 0 && (
                <div className="col-xxl-6 box-col-12">
                  <div className="mb-3">
                    <label className="form-label" htmlFor="Emails">{t('invoice_emails')}</label>
                    <input className="form-control" id="Emails" type="text" placeholder={t('invoice_emails_comma_separated')} onChange={(e) => setEmails(e.target.value)} value={emails} />
                  </div>
                </div>
                )}

                <div className="col-xxl-6 box-col-12">
                  <div className="mb-3">
                    <label className="form-label" htmlFor="Phone">{t('phone')}</label>
                    <input className="form-control" id="Phone" type="text" placeholder={t('phone')} onChange={(e) => setPhone(e.target.value)} value={phone} />
                  </div>
                </div>

                <div className="col-xxl-6 box-col-12">
                  <div className="mb-3">
                    <label className="form-label" htmlFor="BankAccount">{t('bank_account')}</label>
                    <input className="form-control" id="BankAccount" type="text" placeholder={t('bank_account')} onChange={(e) => setBankAccount(e.target.value)} value={bankAccount} />
                  </div>
                </div>

                <div className="col-xxl-6 box-col-12">
                  <div className="mb-3">
                    <label className="form-label" htmlFor="BankAccountName">{t('bank_account_name')}</label>
                    <input className="form-control" id="BankAccountName" type="text" placeholder={t('bank_account_name')} onChange={(e) => setBankAccountName(e.target.value)} value={bankAccountName} />
                  </div>
                </div>

                <div className="col-xxl-6 box-col-12 d-flex align-items-center">
                  <div className="form-check form-switch">
                    <input className="form-check-input" id="interestedInMeatReturn" type="checkbox" role="switch" name="interested_in_meat_return" checked={interestedInMeatReturn} onChange={(e) => setInterestedInMeatReturn(e.target.checked)} />
                    <label className="form-check-label" htmlFor="interestedInMeatReturn">{t('interested_in_meat_return')}</label>
                  </div>
                </div>


                <div className="col-xxl-6 box-col-12">
                  <div className="form-check form-switch">
                    <input className="form-check-input" id="updatePassword" type="checkbox" role="switch" name="update_password" checked={updatePassword} onChange={(e) => setUpdatePassword(e.target.checked)} />
                    <label className="form-check-label" htmlFor="updatePassword">{t('update_password')}</label>
                  </div>
                </div>

                {updatePassword && (
                 <div className="row custom-input">
                <div className="col-xxl-6 box-col-12">
                  <div className="mb-3">
                    <label className="form-label" htmlFor="Password">{t('password')}</label>
                    <input className="form-control" id="Password" type="password" placeholder={t('password')} onChange={(e) => setPassword(e.target.value)} value={password} />
                  </div>
                </div>

                <div className="col-xxl-6 box-col-12">
                  <div className="mb-3">
                    <label className="form-label" htmlFor="PasswordRepeat">{t('repeat_password')}</label>
                    <input className="form-control" id="PasswordRepeat" type="password" placeholder={t('repeat_password')} onChange={(e) => setPasswordRepeat(e.target.value)} value={passwordRepeat} />
                  </div>
                </div></div>)}

              </div>
            </div>

            

            <div className="card-footer text-end">
              {error && <div className="alert alert-danger">{error}</div>}
              {success && <div className="alert alert-success">{success}</div>}
              <button className="btn btn-primary" type="submit">{t('update_profile')}</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default Element;
